import { Plane } from "lucide-react";
export function Footer() {
  const year = new Date().getFullYear();
  const go = (id: string) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="bg-primary text-primary-foreground py-12">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-white/15 border border-white/20 flex items-center justify-center">
              <Plane className="w-4 h-4 text-white rotate-45" />
            </div>
            <span className="text-lg font-black tracking-tight" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              EFIS<span style={{ color: "oklch(0.8 0.15 25)" }}>FLY</span>
            </span>
          </div>
          <nav className="flex flex-wrap justify-center gap-6">
            {["#videos", "#products", "#features", "#specs", "#pricing", "#contact"].map(href => (
              <button key={href} onClick={() => go(href)}
                className="text-sm text-white/60 hover:text-white transition-colors capitalize">
                {href.replace("#", "")}
              </button>
            ))}
          </nav>
          <p className="text-xs text-white/40 font-mono">© {year} EfisFly</p>
        </div>
        <div className="border-t border-white/10 pt-6 flex flex-wrap justify-center gap-x-8 gap-y-1">
          {["G1000NXi Simulation", "FAA / EASA Compatible", "Prepar3D Add-On", "Professional ATO Software"].map(t => (
            <span key={t} className="text-xs text-white/30 font-mono tracking-wider">{t}</span>
          ))}
        </div>
      </div>
    </footer>
  );
}
